import { render, staticRenderFns } from "./MergeCustomers.vue?vue&type=template&id=0ad244e0&scoped=true&"
import script from "./MergeCustomers.vue?vue&type=script&lang=ts&"
export * from "./MergeCustomers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad244e0",
  null
  
)

export default component.exports